import React from 'react';
import { useTranslation } from 'react-i18next';
import { Banner } from '@unmind/design-system';
import { isMSTeams } from 'utils/MSTeams';
import { useUserFeedbackQuery } from 'Shared/FeedbackBanner/useUserFeedbackQuery';
import { getFeedbackFormLink } from 'Assistant/Chatbot/components/ChatbotFeedback/utils';
import { FEEDBACK_LOCALES } from 'i18n/feedbackLocales';
import { getUserLocale } from 'i18n/getUserLocale';
import './ShareFeedback.scss';

const HOMEPAGE_FEEDBACK_SURVEY_LINK = 'https://unmind.typeform.com/to/CkPZGfLI';

const ShareFeedback = () => {
  const { t: translate } = useTranslation('homepage');
  const isTeams = isMSTeams();
  const { data } = useUserFeedbackQuery();
  const feedbackFormLink = getFeedbackFormLink(
    HOMEPAGE_FEEDBACK_SURVEY_LINK,
    data,
  );

  // Only shown for locales the survey itself is translated into.
  if (!FEEDBACK_LOCALES.includes(getUserLocale())) {
    return null;
  }

  return (
    <section className={`share-feedback${isTeams ? ' is-teams' : ''}`}>
      <h2 className="title-s section-title">
        {translate('share_feedback.section_title')}
      </h2>
      <Banner
        title={translate('share_feedback.title')}
        titleElement="h3"
        description={translate('share_feedback.description')}
        iconName="feedback"
        button={{
          label: translate('share_feedback.button'),
          variant: 'primary',
          icon: 'external-link',
          to: feedbackFormLink,
          ...{
            target: '_blank',
            rel: 'noopener noreferrer',
          },
          size: 'medium',
        }}
      />
    </section>
  );
};

export default ShareFeedback;
